<div class="main-container" data-cy="perio-tooth-details-main-container">
  <div class="input-flex-container header-container" data-cy="perio-tooth-details-header-container">
    <div class="flex-item-arrow " width="25%"><button (click)="previousTooth(toothIndex)" type="button" style="background-color: var(--tdo-purple-light)" data-cy="perio-tooth-details-previous-button"><lucide-icon name="chevron-left" [size]="20"></lucide-icon></button></div>
    <div class="flex-item-Tooth headerMenu" width="50%" data-cy="perio-tooth-details-tooth-index-label">Tooth #{{toothIndex}}</div>
    <div class="flex-item-arrow " width="20%"><button (click)="NextTooth(toothIndex)" type="button" style="background-color: var(--tdo-purple-light)" data-cy="perio-tooth-details-next-button"><lucide-icon name="chevron-right" [size]="20"></lucide-icon></button></div>
  </div>

  <div class="main-flex-container" data-cy="perio-tooth-details-fields-container">

    @if (!flipInputFields) {
      <div class="input-flex-container" data-cy="perio-tooth-details-measurements-header">
        <div class="flex-item header" data-cy="perio-tooth-details-blank-header"></div>
        <div class="flex-item header" data-cy="perio-tooth-details-d-header">D</div>
        <div class="flex-item header" data-cy="perio-tooth-details-c-header">C</div>
        <div class="flex-item header" data-cy="perio-tooth-details-m-header">M</div>
      </div>
    }

    @if (flipInputFields) {
      <div class="input-flex-container" data-cy="perio-tooth-details-flipped-measurements-header">
        <div class="flex-item header" data-cy="perio-tooth-details-flipped-blank-header"></div>
        <div class="flex-item header" data-cy="perio-tooth-details-flipped-m-header">M</div>
        <div class="flex-item header" data-cy="perio-tooth-details-flipped-c-header">C</div>
        <div class="flex-item header" data-cy="perio-tooth-details-flipped-d-header">D</div>
      </div>
    }

    @for (structure of inputStructureOrganizer; track structure) {
      <div class="input-flex-container" [attr.data-cy]="'perio-tooth-details-' + structure.name + '-container'">
        <div class="flex-item header rounded-header" [ngStyle]="{'background-color': structure.color}" [attr.data-cy]="'perio-tooth-details-' + structure.name + '-label'">{{ structure.name }}</div>
        @for (facingObj of structure.buccalFacingObjs; track facingObj) {
          <input type="text"
            [id]="facingObj"
            [name]="facingObj"
            [disabled]="tooth.ToothIsMissing"
            maxlength="1"
            autocomplete="off"
            onfocus="this.select()"
            (focus)="addingStyle(facingObj, structure.color)"
            (blur)="removingStyle(facingObj)"
            class="flex-item input-field 'input-onfocus"
            [class.display-none]="facing !== 'buccal'"
            [(ngModel)]="tooth[facingObj]"
            (ngModelChange)="onValueChange($event, facingObj); emitValueChange()"
            [attr.data-cy]="'perio-tooth-details-' + facingObj + '-input'" />
        }
        @for (facingObj of structure.lingualFacingObjs; track facingObj) {
          <input type="text"
            [id]="facingObj"
            [disabled]="tooth.ToothIsMissing"
            maxlength="1"
            autocomplete="disabled"
            onfocus="this.select()"
            (focus)="addingStyle(facingObj, structure.color)"
            (blur)="removingStyle(facingObj)"
            class="flex-item input-field"
            [class.display-none]="facing !== 'lingual'"
            [(ngModel)]="tooth[facingObj]"
            (ngModelChange)="onValueChange($event, facingObj); emitValueChange()"
            [attr.data-cy]="'perio-tooth-details-' + facingObj + '-input'" />
        }
      </div>
    }

    @for (structure of checkboxStructureOrganizer; track structure) {
      <div class="input-flex-container" [attr.data-cy]="'perio-tooth-details-' + structure.name + '-checkbox-container'">
        <!--<div class="flex-item header">{{ structure.name }}</div>!-->
        <div class="flex-item header rounded-header" [ngStyle]="{'background-color': structure.color, 'color': 'white', 'padding-left': '2px'}" [attr.data-cy]="'perio-tooth-details-' + structure.name + '-checkbox-label'">{{ structure.name }}</div>
        @for (facingObj of structure.buccalFacingObjs; track facingObj) {
          <mat-checkbox
            [(ngModel)]="tooth[facingObj]"
            [disabled]="tooth.ToothIsMissing"
            class="flex-item"
            [class.display-none]="facing !== 'buccal'"
            (ngModelChange)="emitValueChange()"
            [id]="facingObj"
          [attr.data-cy]="'perio-tooth-details-' + facingObj + '-checkbox'"></mat-checkbox>
        }
        @for (facingObj of structure.lingualFacingObjs; track facingObj) {
          <mat-checkbox
            [(ngModel)]="tooth[facingObj]"
            [disabled]="tooth.ToothIsMissing"
            class="flex-item"
            [class.display-none]="facing !== 'lingual'"
            (ngModelChange)="emitValueChange()"
            [id]="facingObj"
          [attr.data-cy]="'perio-tooth-details-' + facingObj + '-checkbox'"></mat-checkbox>
        }
      </div>
    }

    <div class="input-flex-container" data-cy="perio-tooth-details-fur-container">
      <div class="radio-label" data-cy="perio-tooth-details-fur-label">
        FUR - Class
      </div>
      <mat-radio-group [disabled]="tooth.ToothIsMissing" class="radio-group" aria-label="FUR" [(ngModel)]="tooth.ToothFurcationGrade" (ngModelChange)="emitValueChange()" data-cy="perio-tooth-details-fur-radiogroup">
        <mat-radio-button class="radio-button" [value]="0" [color]="colorFUR" data-cy="perio-tooth-details-fur-0-radio">0</mat-radio-button>
        <mat-radio-button class="radio-button" [value]="1" [color]="colorFUR" data-cy="perio-tooth-details-fur-1-radio">1</mat-radio-button>
        <mat-radio-button class="radio-button" [value]="2" [color]="colorFUR" data-cy="perio-tooth-details-fur-2-radio">2</mat-radio-button>
        <mat-radio-button class="radio-button" [value]="3" [color]="colorFUR" data-cy="perio-tooth-details-fur-3-radio">3</mat-radio-button>
        <mat-radio-button class="radio-button" [value]="null" [color]="colorFUR" data-cy="perio-tooth-details-fur-na-radio">n/a</mat-radio-button>
      </mat-radio-group>
      <!--<div class="radio-post-label">
      Class
    </div>!-->
  </div>

  <div class="input-flex-container" data-cy="perio-tooth-details-mob-container">
    <div class="radio-label" data-cy="perio-tooth-details-mob-label">
      MOB - Class
    </div>
    <mat-radio-group [disabled]="tooth.ToothIsMissing" class="radio-group" aria-label="MOB" [(ngModel)]="tooth.ToothMobility" (ngModelChange)="emitValueChange()" data-cy="perio-tooth-details-mob-radiogroup">
      <mat-radio-button class="radio-button" [value]="1" [color]="colorMOB" data-cy="perio-tooth-details-mob-1-radio">1</mat-radio-button>
      <mat-radio-button class="radio-button" [value]="2" [color]="colorMOB" data-cy="perio-tooth-details-mob-2-radio">2</mat-radio-button>
      <mat-radio-button class="radio-button" [value]="3" [color]="colorMOB" data-cy="perio-tooth-details-mob-3-radio">3</mat-radio-button>
      <mat-radio-button class="radio-button" [value]="null" [color]="colorMOB" data-cy="perio-tooth-details-mob-na-radio">n/a</mat-radio-button>
    </mat-radio-group>
    <!--<div class="radio-post-label">
    Class
  </div>!-->
</div>

<div class="input-flex-container" data-cy="perio-tooth-details-missing-container">
  <mat-checkbox [(ngModel)]="tooth.ToothIsMissing"
    class="flex-item checkbox-item"
    (ngModelChange)="emitValueChange()"
    id="ToothIsMissing"
  data-cy="perio-tooth-details-missing-checkbox">Missing Tooth</mat-checkbox>
</div>

<div class="input-flex-container" data-cy="perio-tooth-details-implant-container">
  <mat-checkbox [(ngModel)]="tooth.ToothIsImplant"
    class="flex-item checkbox-item"
    (ngModelChange)="emitValueChange()"
    id="ToothIsImplant"
  data-cy="perio-tooth-details-implant-checkbox">Implant</mat-checkbox>
</div>

</div>






</div>





<!--<div *ngIf="facing === 'buccal'">
<input type="text"
  maxlength="1"
  (ngModelChange)="onValueChange($event, 'FacialProbingDepthD')"
  [(ngModel)]="tooth.FacialProbingDepthD" />
  <input type="text"
    maxlength="1"
    (ngModelChange)="onValueChange($event, 'FacialProbingDepthC')"
    [(ngModel)]="tooth.FacialProbingDepthC" />
    <input type="text"
      maxlength="1"
      (ngModelChange)="onValueChange($event, 'FacialProbingDepthM')"
      [(ngModel)]="tooth.FacialProbingDepthM" />
    </div>

    <div *ngIf="facing === 'lingual'">
      <input type="text"
        maxlength="1"
        (ngModelChange)="onValueChange($event, 'LingualProbingDepthD')"
        [(ngModel)]="tooth.LingualProbingDepthD" />
        <input type="text"
          maxlength="1"
          (ngModelChange)="onValueChange($event, 'LingualProbingDepthC')"
          [(ngModel)]="tooth.LingualProbingDepthC" />
          <input type="text"
            maxlength="1"
            (ngModelChange)="onValueChange($event, 'LingualProbingDepthM')"
            [(ngModel)]="tooth.LingualProbingDepthM" />
          </div>-->
